import {Vue} from "vue/types/vue";
import {Store} from "vuex";
import {DelierState, ViewportState} from "@/store/store";
import BrowserDetector from '@/services/BrowserDetector';

type VueElement = Vue | Element | Vue[] | Element[]; // spoiler : ik weet stiekem al dat het een HTMLElement is

export class ScrollingViewport {

    // scaling

    private viewport?:HTMLElement;
    private content?:HTMLElement;
    private root?:HTMLElement;
    private aspect:number = 1;
    private contentScale:number = 1.5;
    private smoothness:number = .995; // 0 < smoothness < 1
    private designWidth:number = 100; // needed to calc designScaling
    private designHeight:number = 100; // needed to calc designScaling
    private designScaling:number = 1; // what is the scale compared to design
    private minAspect:number = 4/3;
    private maxAspect:number = 13/6;

    // scrolling

    private isAnimating:boolean = false;
    private isPaused:boolean = false;
    private isHidden:boolean = false;
    private animX:number = 0; // 0...1 movement pos
    private animY:number = 0;
    private targetX:number = 0;
    private targetY:number = 0;
    private movementW:number = 0; // move room in pixels
    private movementH:number = 0; // move room in pixels
    private prevTime:number = 0; // timestamp of previous frame
    private offsetX:number = 0;
    private offsetY:number = 0;

    // Vue shit

    private state?:DelierState;

    constructor(){
    }

    public register( state:DelierState, viewport:VueElement, content:VueElement, root:VueElement|HTMLElement|null, designWidth:number, designHeight:number ):void {
        //console.log('register', viewport instanceof HTMLElement, content instanceof HTMLElement);
        this.state = state;
        this.viewport = <HTMLElement>viewport;
        this.content = <HTMLElement>content;
        this.root = <HTMLElement>root;
        this.aspect = designWidth / designHeight;
        this.designWidth = designWidth;
        this.designHeight = designHeight;

        window.addEventListener("resize", this.handleResize);
        window.addEventListener("mousemove", this.handleMouseMove);

        this.updateContentSizeRestricted();
        this.isAnimating = true;
        window.requestAnimationFrame(this.animateStep);
    }

    public unregister():void {
        //console.log('unregister');
        window.removeEventListener("resize", this.handleResize);
        window.removeEventListener("mousemove", this.handleMouseMove);
        this.isAnimating = false;
    }

    private handleResize(e:any):void {
        //console.log(navigator.userAgent);
        // if (/MSIE/i.test(navigator.userAgent)) {
             //let root = window.document.documentElement;
             //console.log(navigator.userAgent, window.innerWidth, window.innerHeight, _instance.root);

        if( BrowserDetector.browser === 'Explorer' ) {
            if( _instance.root ) {
                _instance.setElementSize(_instance.root, window.innerWidth, window.innerHeight);
            }
        }

        // }
        // console.log(window.document);
        // try {
        //     console.log(window.document["documentElement"]);
        // } catch(e) {
        //     console.log(e);
        // }
        _instance.updateContentSizeRestricted(); // 'this' verwijst naar Window, daarom _instance nodig
    }

    private handleMouseMove(e:MouseEvent):void {
        _instance.onMouseMove(e.pageX, e.pageY);
    }

    private clamp(x:number, min:number, max:number) {
        return x < min ? min : (x > max ? max : x);
    }

    private onMouseMove(x:number, y:number):void {
        if (this.isPaused) {
            this.targetX = this.targetY = 0.5;
        } else {
            //this.targetX = this.clamp(x / window.innerWidth, 0, 1);
            //this.targetY = this.clamp(y / window.innerHeight, 0, 1);
            let width:number = this.viewport === undefined ? window.innerWidth : this.viewport.offsetWidth;//this.viewportWidth;
            let height:number = this.viewport === undefined ? window.innerHeight: this.viewport.offsetHeight;//this.viewportHeight;
            let left:number = this.viewport === undefined ? 0 : this.viewport.offsetLeft;
            let top:number = this.viewport === undefined ? 0 : this.viewport.offsetTop;
            this.targetX = this.clamp((x-left) / width, 0, 1);
            this.targetY = this.clamp((y-top) / height, 0, 1);
        }
    }

    private animateStep(timestamp:number):void {
        _instance.onAnimate(timestamp);
    }

    private onAnimate(timestamp:number):void {
        if( this.isAnimating ) {
            var deltaTime = this.clamp(timestamp - this.prevTime, 1, 250);
            this.prevTime = timestamp;

            let t = (1 - this.smoothness) * deltaTime;
            this.animX = (1.0-t) * this.animX + t * this.targetX;
            this.animY = (1.0-t) * this.animY + t * this.targetY;

            if( this.content ) {
                this.setElementPosition(this.content, -this.movementW * this.animX + this.offsetX, -this.movementH * this.animY + this.offsetY)
            }

            window.requestAnimationFrame(this.animateStep);
        }
    }

    public getContentScale():number {
        return this.designScaling;
    }

    public updateContentSizeRestricted():void {

        // this.updateContentSize();
        // return;

        if( this.viewport && this.content ) {

            let width = window.innerWidth; // this.viewport.clientWidth;
            let height = window.innerHeight; //  this.viewport.clientHeight;
            let viewportAspect: number = width / height;

            // scale viewport first, updating width/height to the viewport area (rather than window area)
            {
                let viewportWidth: number = width;
                let viewportHeight: number = height;
                if (viewportAspect > this.maxAspect) {
                    viewportWidth = viewportHeight * this.maxAspect;
                }
                else if (viewportAspect < this.minAspect) {
                    viewportHeight = viewportWidth / this.minAspect;
                }
                let marginWidth = .5 * (width - viewportWidth);
                let marginHeight = .5 * (height - viewportHeight);
                this.viewport.style.left = marginWidth + 'px';
                this.viewport.style.right = marginWidth + 'px';
                this.viewport.style.top = marginHeight + 'px';
                this.viewport.style.bottom = marginHeight + 'px';
                width = viewportWidth;
                height = viewportHeight;
            }

            let videoWidth:number;
            let videoHeight:number;

            // calc

            let widthFirst:boolean = viewportAspect < this.aspect;

            if( widthFirst ) {
                videoWidth = width * this.contentScale;
                videoHeight = videoWidth / this.aspect;
            }
            else {
                videoHeight = height * this.contentScale;
                videoWidth = videoHeight * this.aspect;
            }

            this.movementW = videoWidth - width;
            if( this.movementW < 0) {
                this.offsetX = -.5 * this.movementW;
                this.movementW = 0;
            } else {
                this.offsetX = 0;
            }

            this.movementH = videoHeight - height;
            if( this.movementH < 0) {
                this.offsetY = -.5 * this.movementH;
                this.movementH = 0;
            } else {
                this.offsetY = 0;
            }

            // apply

            this.designScaling = videoWidth / this.designWidth;
            if( this.state ) {
                // truuk zodat de resize effect heeft ap alle vue dependency trees
                this.state.viewportScale = this.designScaling;
            }
            this.setElementSize(this.content, videoWidth, videoHeight);
        }
    }

    public updateContentSize():void {
        if( this.viewport && this.content ) {
            let width = window.innerWidth; // this.viewport.clientWidth;
            let height = window.innerHeight; //  this.viewport.clientHeight;
            let viewportAspect:number = width / height;

            let videoWidth:number;
            let videoHeight:number;

            if( viewportAspect > this.aspect ) {
                // viewport is relatief breed
                videoWidth = this.contentScale * width;
                videoHeight = this.contentScale * width / this.aspect;
            }
            else {
                // viewport is relatief hoog
                videoWidth = this.contentScale * height * this.aspect;
                videoHeight = this.contentScale * height;
            }
            this.designScaling = videoWidth / this.designWidth;
            if( this.state ) {
                // truuk zodat de resize effect heeft ap alle vue dependency trees
                this.state.viewportScale = this.designScaling;
            }
            this.setElementSize(this.content, videoWidth, videoHeight);

            this.movementW = videoWidth - width;
            this.movementH = videoHeight - height;
        }
    }

    private setElementSize(el:HTMLElement, width:number, height:number):void {
        //console.log('setElementSize', width, height);
        el.style.width = width + 'px';
        el.style.height = height + 'px';
    }

    private setElementPosition(el:HTMLElement, x:number, y:number):void {
        //console.log('setElementSize', width, height);
        el.style.left = x + 'px';
        el.style.top = y + 'px';
    }

    public setPause(pause:boolean):void {
        this.isPaused = pause;
        if( pause ) {
            this.targetX = this.targetY = 0.5;
        }
    }

    public setHide(hide:boolean):void {
        if( hide != this.isHidden && this.viewport !== undefined ) {
            this.isHidden = hide;
            //this.viewport.style.opacity = hide ? '0' : '1';
            this.viewport.style.display = hide ? 'none' : 'block';
        }
    }

    public stateFromRoute(state:DelierState, routeName:string):ViewportState {
        switch (routeName) {
            case "nurse":
            case "morning":
            case "night":
                if (state.showExitConfirm)
                    return ViewportState.center;
                else
                    return ViewportState.follow;
            case "computer":
            case "feedback":
            case "hotspot":
                return ViewportState.center;
            default:
                return ViewportState.hidden;
        }
    }
}

const _instance = new ScrollingViewport(); // is nodig voor resize event

// Stijn: is dit een singleton, zie: https://stackoverflow.com/questions/30174078/how-to-define-singleton-in-typescript
export default _instance; //new ScrollingViewport();
